import { AppConfigSet, loadAppSetUp } from '@gjensidige/se-content-helpers';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';

export class AppHelper {
  static AppTexts: any = {};
  static AppIllustrations: any = [];

  static getText = (key: string): string => {
    return AppHelper.AppTexts ? AppHelper.AppTexts[key] : '';
  };

  static fetchInitialData = async () => {
    const configSet = [AppConfigSet.GENERIC_ILLUSTRATION];
    const staticData = await loadAppSetUp('calculation-widget-se', configSet);
    AppHelper.AppTexts = staticData[0];
    AppHelper.AppIllustrations = JSON.stringify(staticData[1]);
  };

  static fetchImageUrl = async (
    fileName: string,
    fileType: IllustrationType
  ) => {
    return fetchGenericIllustrations(
      fileName,
      fileType,
      JSON.parse(AppHelper.AppIllustrations)
    );
  };
}
